import pino from "pino";
import config from "@/config";

const logger = pino({
  level: config.environment === "production" ? "error" : "debug",
});

export default logger;
